module.exports = __webpack_public_path__ + "media/images/sp/stores/namba/namba_sns_01-e17e9ed7f46515451681fa7b4f014c18.jpg";